import styled from '@emotion/styled'
import { MutableRefObject, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import Title from '../global/Title'

type Props = {
    tryTextRef: MutableRefObject<HTMLDivElement | null>
    tarifTextRef: MutableRefObject<HTMLDivElement | null>
}

const Prices = ({ tryTextRef, tarifTextRef }: Props) => {
    const location = useLocation()

    const { t } = useTranslation('translation')

    useEffect(() => {
        const hash = location.hash
        const el = hash && document.getElementById(hash.substring(1))

        if (el) {
            setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 1000)
        }
    }, [])

    return (
        <>
            <Title ref={tryTextRef}>{t('page.price.title-try')}</Title>
            <PriceContainer>
                <p>
                    {t('page.price.price-try-1')} <br />
                    {t('page.price.price-try-2')} <br />
                    {t('page.price.price-try-3')} <br />
                </p>
            </PriceContainer>
            <Title ref={tarifTextRef} id="tarif">
                {' '}
                {t('page.price.title')}
            </Title>
            <PriceContainer>
                {t('page.price.first-price-date-1')} :
                <ul>
                    <li>{t('page.price.young-1')}</li>
                    <li>{t('page.price.competitor-1')}</li>
                    <li>{t('page.price.leisure-1')}</li>
                    <li>{t('page.price.para-competitor-1')}</li>
                    <li>{t('page.price.para-leisure-1')}</li>
                </ul>
            </PriceContainer>
            <PriceContainer>
                {t('page.price.first-price-date-2')} :
                <ul>
                    <li>{t('page.price.young-2')} </li>
                    <li>{t('page.price.competitor-2')} </li>
                    <li>{t('page.price.leisure-2')} </li>
                    <li>{t('page.price.para-competitor-2')} </li>
                    <li>{t('page.price.para-leisure-2')} </li>
                </ul>
            </PriceContainer>
        </>
    )
}

const PriceContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background: white;
    padding: 16px;
    border-radius: 6px;
    margin-bottom: 16px;
    box-sizing: border-box;
    font-size: 20px;
`

export default Prices
